export default {
    user: 'Advisor',
    bdc_user: 'BDC Agent',
};
